import React from "react";
import ActivityLogMenu from "../components/menu/admin/ActivityLogMenu";

const ActivityLog = () => {
  return <ActivityLogMenu />;
};
export default ActivityLog;
